module.exports = __webpack_public_path__ + "img/MALL.a99e6f6c.svg";